<template>
	<div class="status-container" :style="styles[data]">
		{{ situacaoDesc[data] }}
	</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			situacaoDesc: {
				0: 'Salvo',
				1: 'Finalizado',
				2: 'Integrado',
				3: 'Inválido',
				4: 'Em Análise',
				5: 'Liberado',
				6: 'Faturado',
				7: 'Cancelado',
				8: 'Transporte',
				9: 'Entregue',
				10: 'Aguardando Pagamento',
				11: 'Em rota',
			},
			styles: {
				0: 'background-color: #8338ec1f; color: #8338ec;',
				1: 'background-color: #cdffcd; color: #007f00;',
				2: 'background-color: #f200891f; color: #f20089;',
				3: 'background-color: #dc2f021f; color: #dc2f02;',
				4: 'background-color: #ffa01c5d; color: rgb(140 81 0);',
				5: 'background-color: #007f5f1f; color: rgb(0 88 66);',
				6: 'background-color: #003f881f; color: #003f88;',
				7: 'background-color: #e71d361f; color: rgb(179 22 41);',
				8: 'background-color: #ffbe0b0d; color: #ffbe0b;',
				9: 'background-color: #003f881f; color: #003f88;',
				10: 'background-color: #ffc0005d; color: rgb(140 81 0);',
				11: 'background-color: #007f5f1f; color: #007f5f;',
			},
		};
	},
};
</script>

<style scoped>
.status-container {
	display: flex;
	padding: 2.5px 5px;
	width: 100%;
	align-items: center;
	justify-content: center;
	border-radius: 50px;
	font-size: 11px;
	font-weight: 600;
}
</style>

